import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { templatesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useTemplatesState = () => React.useContext(Context)
export const useTemplates = () => useTemplatesState()?.templates

const QUERY = gql`
  query Templates($page: Int, $sort: TemplateSort, $filter: TemplateFilter) {
    templates(page: $page, sort: $sort, filter: $filter) {
      id
      name
      enabled
      entity
      type
      description
      documentId
      checklist {
        id
        name
      }
      updatedAt
      insertedAt
    }
  }
`

const TemplatesLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const { data: entity } = useCurrentModal()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'NAME', type },
      filter: { entities: [entity], types: ['docx', 'dynamic_pdf'] }
    },
    client: templatesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TemplatesLoader
